import React, { useEffect, useState } from 'react';
import { msalConfig, aquireToken } from './MsalConfig';
import { PulseLoader } from 'react-spinners';
import Center from 'react-center';
import VeroApp from '../components/VeroApp';
import * as msal from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';

const App = () => {
    const [loggedIn, setLoggedIn] = useState(false);
    const { instance: msalInstance } = useMsal();
    const isAuthenticated = useIsAuthenticated();


    useEffect(() => {
        // hide env vars
        //console.log(process.env);
        // Set active acccount on page load
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
            setLoggedIn(true);
            aquireToken(msalInstance);
        }
        // Event callback to handle
        msalInstance.addEventCallback((event) => {
            // set active account after redirect
            if (
                event.eventType === msal.EventType.LOGIN_SUCCESS &&
                event.payload.account
            ) {
                const account = event.payload.account;
                msalInstance.setActiveAccount(account);
                setLoggedIn(true);
                aquireToken(msalInstance);
            }
        });

        //console.log('get active account', msalInstance.getActiveAccount());

        // handle auth redired/do all initial setup for msal
        msalInstance
            .handleRedirectPromise()
            .then((authResult) => {
                // Check if user signed in
                const account = msalInstance.getActiveAccount();
                if (!account) {
                    // redirect anonymous user to login page
                    msalInstance.loginRedirect();
                }
            })
            .catch((err) => {
                // TODO: Handle errors
                console.log(err);
            });
    });

    if (loggedIn) {
        return <VeroApp />;
    } else {
        return (
            <div>
                <Center>
                    <div className="loadSplash">
                        <h1> Not logged in </h1>
                        <div className="loader">
                            <PulseLoader
                                sizeUnit={'px'}
                                size={8}
                                color={'#222222'}
                            />
                        </div>
                    </div>
                </Center>
            </div>
        );
    }
};

export default App;
